import classnames from 'classnames';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import routerCfg, { fillPathAppId } from 'routerCfg';
import getTT from 'getTT';
import styles from './style.scss?__local';
import imgExt from 'assets/img/ext_default.png';
import Utils from 'Utils'
import { Icon } from 'antd'
import InstallBtn from '@cmps/InstallBtn/InstallBtn'

const ColorStyles = {
  '1': { background: 'linear-gradient(141deg, #25AAE5 0%, #338FDE 100%)' },
  '2': { background: 'linear-gradient(141deg, #ff4d4f 0%, #ff7875 100%)' },
};

// 小程序商店首页 小程序卡片
function App({ data }) {
  const ID = data.extVersionType == 3 ? data.extUuid : (`${data.extUuid}-${data.extVersionType == 4 ? data.extVersion : data.extVersionId}`)
  const ICON = data.extLogo ? (data.extLogo + '?x-oss-process=image/resize,limit_0,m_fill,w_152,h_152/sharpen,80/format,png/interlace,1/quality,q_90/rounded-corners,r_76') : imgExt

  const hadServiceFee = data.hadServiceFee;
  const installFee = data.installationFee;

  const getTagText = () => {
    let tagText = '';

    if (installFee) {
      tagText = `¥${installFee / 100}`;
    } else if (hadServiceFee) {
      tagText = '服务费'
    } else {
      tagText = '免费';
    }

    return tagText;
  }

  const reportClick = () => {
    yaReportArr.push({
      eid: 'usr/click/appstore/home/extItem',
      eid_desc: '点击/小程序商店首页/小程序',
      prop: {
        extId: ID,
      },
    })
  }

  const renderLivingList = () => {
    const { hasUseProfileData, useProfileList } = data;

    // const hasUseProfileData = true
    // const useProfileList = [{roomId: 18220076, yyid:909040639, nick: '1231', logo: 'https://huyaimg.msstatic.com/avatar/1025/8c/f88e521829580d91a4ac1a62849842_180_135.jpg?1553689903'}]

    // if (!hasUseProfileData || !useProfileList || useProfileList.length <= 0) {
    if (!useProfileList || useProfileList.length <= 0) {
      return null
    }

    const handleClickAvatar = e => {
      e.stopPropagation();
    }

    return (
      <div className={styles.living}>
        <ul className={styles.list}>
          {
            useProfileList
              .sort((left, right) => parseInt(right.audienceNum, 10) - parseInt(left.audienceNum, 10))
              .slice(0, 5)
              .map(item => (
                <li className={styles.item} key={item.yyid} onClick={handleClickAvatar} title={item.nick}>
                  <a href={Utils.getRoomUrl(item)} target="_blank">
                    <img src={item.logo} alt="" onError={Utils.avatarErrorHandler} />
                  </a>
                </li>),
              )
          }
        </ul>
      </div>
    )
  }

  const renderTagList = (keywords) => {
    const tagListArr = keywords || []

    return (
      <div className={styles.tagsContent}>
        {
          tagListArr
            .slice(0, 3)
            .map((item, idx) => (
              <div className={styles.tagItem} key={`tag_${idx}`}>
                <div className={styles.tagText}>
                  <span className={styles.tagDesc}>{item}</span>
                </div>
              </div>
            ))
        }
      </div>
    )
  }



  const renderCorner = (badgeLabelInfo) => {
    // const cornerText = '限时免费';

    if (!badgeLabelInfo) return null;
    return (
      <div className={styles.corner} style={ColorStyles[`${badgeLabelInfo.color}`]}>
        <span className={styles.cornerText} >{badgeLabelInfo?.badgeLabel}</span>
      </div>
    )
  }

  return (
    <div className={styles.app}>
      <Link className={styles.content} to={fillPathAppId(routerCfg.path.app, ID)} onClick={reportClick} target="_blank">
        <div className={styles.topInfo}>
          <div className={styles.media} title={data.extName}>
            <img src={ICON} alt={data.extName} />
          </div>

          <div className={styles.product}>
            <div className={styles.name}>
              <span className={styles.text} title={data.extName}>{data.extName}</span>
              {Object.values(data.extTagInfos || {}).includes('小游戏') ? <span className={styles.label}>小游戏</span> : null}
              {data.extVersionType == 1 ? <span className={styles.label}>开发</span> : null}
              {data.extVersionType == 2 ? <span className={styles.label}>测试</span> : null}
            </div>

            {renderLivingList()}

            {renderTagList(data.keywords)}

          </div>
        </div>

        {data.extBrief && (
          <div className={styles.brief} title={data.extBrief}>
            {data.extBrief}
          </div>
        )}
      </Link>

      <div className={styles.install}>
        <InstallBtn
          hadInstall={data.hadInstall}
          extUuid={data.extUuid}
          extName={data.extName}
        />
      </div>

      {renderCorner(data.badgeLabelInfo)}
    </div>
  )
}

export default App
